import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { UncontrolledTooltip } from "reactstrap";
import { ReportSectionHeader } from "../SectionHeader";

const ClassPeriodOfferingsComponent = (props) => (

	<div>
		<ReportSectionHeader>
			<div id={"classPeriodTradingStatTitle"} className={"SectionHeaderInner"}>
				{"Offering Summary Information"}
			</div>
			<UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
				target={"classPeriodTradingStatTitle"}>
				{""}
				
			</UncontrolledTooltip>
		</ReportSectionHeader>
		<ReportTable
			settings={[
				{
					header: 'Offering Date',
					accessor: 'date',
				},
				{
					header: 'Offering Type',
					accessor: 'offeringType',
					
				},
				{
					header: 'Shares Issued~(000s)', 
					accessor: 'offeringShares',
					formatNumberWithCommas: true,
					inThousands: true,
					centerRightJustified: true,
					dollarValue: false,
					round2whole: true
				},
				{
					header: 'Offering Price', 
					accessor: 'offeringPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Capital Raised~(000s)', 
					accessor: 'raisedAmount',
					inThousands: true,
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true
				}
			]}
			data={props.classPeriodOfferings}
			name={"classPeriodOffering"}
			accumulator={"raisedAmount"}
            accumulatorDisplay={"Total Capital Raised" }
		/>
	</div>
);


export default ClassPeriodOfferingsComponent;


// WEBPACK FOOTER //
// ./src/common/components/ClassPeriodOfferings/ClassPeriodOfferingsComponent.js